import type { CurvePoint } from './types';

/**
 * Clamp a value between a minimum and maximum
 */
export function clamp(v: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, v));
}

/**
 * Linear interpolation along a curve
 */
export function lerp(t: number, curve: CurvePoint[]): number {
  if (t <= curve[0].x) return curve[0].y;
  if (t >= curve[curve.length - 1].x) return curve[curve.length - 1].y;

  for (let i = 1; i < curve.length; i++) {
    if (t <= curve[i].x) {
      const seg = (t - curve[i - 1].x) / (curve[i].x - curve[i - 1].x);
      return curve[i - 1].y + seg * (curve[i].y - curve[i - 1].y);
    }
  }

  return curve[curve.length - 1].y;
}
